export default {
  years: "Years",
  countries: "Countries",
  leadership: "Leadership",
  quality: "Quality",
  solutions: "Solutions",
  facilities: "Facilities",
  approvals: "Approvals",
  customers: "Customers",
  operations: "Operations",
  focused: "Focused",
  vision: "Vision",
};

